export const messages = {
  en: {
    goldDetail: {
      queryCondition: 'Query Conditions',
      goldIdPlaceholder: 'Please enter gold account',
      goldNamePlaceholder: 'Please enter community name',
      objIdPlaceholder: 'Please enter community ID',
      orderIdPlaceholder: 'Please enter transaction number',
      query: 'Query',
      goldTransaction: 'Gold Transaction',
      id: 'ID',
      goldAccount: 'Gold Account',
      type: 'Type',
      transferIn: 'Transfer In',
      transferOut: 'Transfer Out',
      communityName: 'Community Name',
      communityId: 'Community ID',
      transactionAmount: 'Transaction Amount',
      currentAmount: 'Current Amount',
      transactionNo: 'Transaction No',
      remark: 'Remark',
      time: 'Time'
    }
  },
  zh: {
    goldDetail: {
      queryCondition: '查询条件',
      goldIdPlaceholder: '请填写金币账户',
      goldNamePlaceholder: '请填写小区名称',
      objIdPlaceholder: '请填写小区编号',
      orderIdPlaceholder: '请填写交易单号',
      query: '查询',
      goldTransaction: '金币交易',
      id: '编号',
      goldAccount: '金币账户',
      type: '类型',
      transferIn: '转入',
      transferOut: '转出',
      communityName: '小区名称',
      communityId: '小区编号',
      transactionAmount: '交易金额',
      currentAmount: '当前金额',
      transactionNo: '交易单号',
      remark: '备注',
      time: '时间'
    }
  }
}